<template>
  <div class="paymentFailed">
    <img
      class="paymentFailed-img"
      src="@/assets/icons/AuthenticationFailedRegister.svg"
      alt=""
    />
    <p class="paymentFailed-title">
      {{ $t('paymentFailed') }}
    </p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'PaymentFailed'
})
export default class PaymentFailed extends Vue {}
</script>

<style lang="scss" scoped>
.paymentFailed {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  height: 176px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: $light-grey;
  .paymentFailed-img {
    margin-bottom: 20px;
    background-color: $light-grey;
  }
  .paymentFailed-title {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 600;
    background-color: $light-grey;
  }
}
</style>
